import { action } from '@ember/object';
import PostList from '@linc-technologies/linced-common/components/post-list';
import PostStatus from '@linc-technologies/linced-common/enums/post-status';

export default class PublishablePostList extends PostList {
  PostStatus = PostStatus;

  shouldDisableActions() {
    return this.disableActions;
  }

  @action
  handleShouldDisableActions(post) {
    return this.shouldDisableActions(post);
  }
}
